const _ = require('lodash');

module.exports = function({ addUtilities, theme }) {
  addUtilities({
    '.icon-line': {
      display: 'flex',
      'align-items': 'center',
    },
    '.icon': {
      'flex-shrink': 0,
      display: 'inline-block',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
    },
    ..._.mapKeys(
      _.mapValues(theme('spacing'), value => {
        return {
          width: value,
          height: value,
        };
      }),
      (value, key) => `.icon-${key}`
    ),
    '.icon-phone': {
      'background-image': 'url("/img/web/icons/phone.svg")',
    },
    '.icon-email': {
      'background-image': 'url("/img/web/icons/email.svg")',
    },
    '.icon-envelope': {
      'background-image': 'url("/img/web/icons/envelope.svg")',
    },
    '.icon-phone-blue': {
      'background-image': 'url("/img/web/icons/phone-blue.svg")',
    },
    '.icon-email-blue': {
      'background-image': 'url("/img/web/icons/email-blue.svg")',
    },
    '.icon-team': {
      'background-image': 'url("/img/web/icons/team.svg")',
    },
    '.icon-blog': {
      'background-image': 'url("/img/web/icons/blog.svg")',
    },
    '.icon-agreement': {
      'background-image': 'url("/img/web/icons/agreement.svg")',
    },
    '.icon-star': {
      'background-image': 'url("/img/web/icons/star.svg")',
    },
    '.icon-star-black': {
      'background-image': 'url("/img/web/icons/star-black.svg")',
    },
    '.icon-question': {
      'background-image': 'url("/img/web/icons/question.svg")',
    },
    '.icon-question-dark': {
      'background-image': 'url("/img/web/icons/question-dark.svg")',
    },
    '.icon-alert': {
      'background-image': 'url("/img/web/icons/alert.svg")',
    },
    '.icon-warning': {
      'background-image': 'url("/img/web/icons/warning.svg")',
    },
    '.icon-faq': {
      'background-image': 'url("/img/web/icons/faq.svg")',
    },
    '.icon-arrow': {
      'background-image': 'url("/img/web/icons/arrow.svg")',

      '.fotocasa &': {
        'background-image': 'url("/img/fotocasa-hipotecas/icons/arrow.svg")',
      },
    },
    '.icon-ok': {
      'background-image': 'url("/img/web/icons/ok.svg")',
    },
    '.icon-stats': {
      'background-image': 'url("/img/web/icons/stats.svg")',
    },
    '.icon-home': {
      'background-image': 'url("/img/web/icons/home.svg")',
    },
    '.icon-clock': {
      'background-image': 'url("/img/web/icons/clock.svg")',

      '.fotocasa &': {
        'background-image': 'url("/img/fotocasa-hipotecas/icons/clock.svg")',
      },
    },
    '.icon-calendar': {
      'background-image': 'url("/img/web/icons/calendar.svg")',

      '.fotocasa &': {
        'background-image': 'url("/img/fotocasa-hipotecas/icons/calendar.svg")',
      },
    },
    '.icon-att': {
      'background-image': 'url("/img/web/icons/att.svg")',
    },
    '.icon-breadcrumb-separator': {
      'background-image': 'url("/img/web/icons/breadcrumb-separator.svg")',
    },
    '.icon-play': {
      'background-image': 'url("/img/web/icons/play.svg")',
    },
    '.icon-magnifying': {
      'background-image': 'url("/img/web/icons/magnifying.svg")',
    },
    '.icon-phone-call': {
      'background-image': 'url("/img/web/icons/phone-call.svg")',
    },
    '.icon-ofertas': {
      'background-image': 'url("/img/web/icons/ofertas.svg")',
    },
    '.icon-key': {
      'background-image': 'url("/img/web/icons/key.svg")',
    },
    '.icon-arrow-lg': {
      'background-image': 'url("/img/web/form/right-arrow-btn.svg")',
    },
  });
};
